<template>
  <Layout>
    <div class="container">
      <div class="header-operations mb-5">
      </div>
      <div class="main-operations">
        <cardOperaion
          v-bind="item"
          v-for="item in visibleOperations"
          :key="item.modal"
          @click="openModal(item.modal)"
        />
      </div>
    </div>
    <modalDeleteAccountStatement v-if="canOperationsActions" />
    <modalConfigGateway v-if="canOperationsActions" />
    <modalInsertIndication v-if="canOperationsActions" />
    <modalAdjustSale v-if="canOperationsActions" />
    <modalRemoveUserSettings v-if="canOperationsActions" />
    <modalAdjustSaleAmounts v-if="canOperationsActions" />
    <modalAddTransectionGatewayInSale v-if="canOperationsActions" />
    <modalCreateTicket v-if="canOperationsActions" />
    <modalInsertUserFlag v-if="canOperationsActions" />
    <modalProcessNotFound v-if="canOperationsActions" />
    <modalRemoveReconciliation v-if="canOperationsActions" />
    <modalReprocessSale v-if="canOperationsActions" />
    <modalDeleteTotalSale v-if="canOperationsActions" />
    <modalLookupTransaction v-if="canLookupTransaction" />
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import cardOperaion from '@/src/components/operations/cardOperaion.vue'
import modalDeleteAccountStatement from '@/src/components/operations/modal/modalDeleteAccountStatement.vue'
import modalConfigGateway from '@/src/components/operations/modal/modalConfigGateway.vue'
import modalInsertIndication from '@/src/components/operations/modal/modalInsertIndication.vue'
import modalAdjustSale from '@/src/components/operations/modal/modalAdjustSale.vue'
import modalRemoveUserSettings from '@/src/components/operations/modal/modalRemoveUserSettings.vue'
import modalAdjustSaleAmounts from '@/src/components/operations/modal/modalAdjustSaleAmounts.vue'
import modalCreateTicket from '@/src/components/operations/modal/modalCreateTicket.vue'
import modalInsertUserFlag from '@/src/components/operations/modal/modalInsertUserFlag.vue'
import modalAddTransectionGatewayInSale from '@/src/components/operations/modal/modalAddTransectionGatewayInSale.vue'
import modalProcessNotFound from '@/src/components/operations/modal/modalProcessNotFound.vue'
import modalRemoveReconciliation from '@/src/components/operations/modal/modalRemoveReconciliation.vue'
import modalReprocessSale from '@/src/components/operations/modal/modalReprocessSale.vue'
import modalDeleteTotalSale from '@/src/components/operations/modal/modalDeleteTotalSale.vue'
import modalLookupTransaction from '@/src/components/operations/modal/modalLookupTransaction.vue'
import { canAccessAction } from '@utils/permissions'
import validAcessRoute from '@utils/validAcessRoute'
import { AccessLevel } from '@views/configurations/enums/accessLevel'

export default {
  components: {
    Layout,
    cardOperaion,
    modalDeleteAccountStatement,
    modalConfigGateway,
    modalInsertIndication,
    modalAdjustSale,
    modalRemoveUserSettings,
    modalAddTransectionGatewayInSale,
    modalAdjustSaleAmounts,
    modalCreateTicket,
    modalInsertUserFlag,
    modalProcessNotFound,
    modalRemoveReconciliation,
    modalReprocessSale,
    modalDeleteTotalSale,
    modalLookupTransaction,
  },
  data() {
    return {
      listOperations: [
        {
          name: 'Lookup Transaction',
          icon: 'fa-search',
          modal: 'modalLookupTransaction',
          permission: 'lookup',
        },
        {
          name: 'Delete Account Statement',
          icon: 'fa-trash',
          modal: 'modalDeleteAccountStatement',
          permission: 'actions',
        },
        {
          name: 'Insert Specific Gateway',
          icon: 'fa-cog',
          modal: 'modalConfigGateway',
          permission: 'actions',
        },
        {
          name: 'Insert indication',
          icon: 'fa-arrow-up',
          modal: 'modalInsertIndication',
          permission: 'actions',
        },
        {
          name: 'Sale adjustment',
          icon: 'fa-exclamation-circle',
          modal: 'modalAdjustSale',
          permission: 'actions',
        },
        {
          name: 'Delete Users Settings/flags',
          icon: 'fa-user-slash',
          modal: 'modalRemoveUserSettings',
          permission: 'actions',
        },
        {
          name: 'Adjust sale values',
          icon: 'fa-money-bill-wave',
          modal: 'modalAdjustSaleAmounts',
          permission: 'actions',
        },
        {
          name: 'Create Ticket',
          icon: 'fa-ticket-alt',
          modal: 'modalCreateTicket',
          permission: 'actions',
        },
        {
          name: 'Insert Users Settings/flags',
          icon: 'fa-flag',
          modal: 'modalInsertUserFlag',
          permission: 'actions',
        },
        {
          name: 'Comando Sale Not Found',
          icon: 'fa-search',
          modal: 'modalProcessNotFound',
          permission: 'actions',
        },
        {
          name: 'Remove Reconciliation',
          icon: 'fa-undo',
          modal: 'modalRemoveReconciliation',
          permission: 'actions',
        },
        {
          name: 'Delete full sale',
          icon: 'fa-lock',
          modal: 'modalDeleteTotalSale',
          permission: 'actions',
        },
        {
          name: 'Reprocess sale',
          icon: 'fa-redo',
          modal: 'modalReprocessSale',
          permission: 'actions',
        },
        {
          name: 'Insert transaction and gateway',
          icon: 'fa-solid fa-dollar-sign',
          modal: 'modalAddTransectionGatewayInSale',
          permission: 'actions',
        },
      ],
    }
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile || {}
    },
    useNewPermissions() {
      return !!this.profile.use_action_permissions
    },
    canLookupTransaction() {
      if (this.useNewPermissions) {
        return canAccessAction(this.$store, 'operations_lookup_transaction', AccessLevel.READER)
      }

      return validAcessRoute(['operations', 'operations_viewer'], this.profile) > 0
    },
    canOperationsActions() {
      if (this.useNewPermissions) {
        return canAccessAction(this.$store, 'operations_actions_access', AccessLevel.EDITOR)
      }

      return validAcessRoute(['operations'], this.profile) > 0
    },
    visibleOperations() {
      return this.listOperations.filter((item) => {
        if (item.permission === 'lookup') {
          return this.canLookupTransaction
        }

        return this.canOperationsActions
      })
    },
  },
  methods: {
    openModal(name) {
      this.$bvModal.show(name)
    },
  },
}
</script>

<style scoped>
.main-operations {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 100px;
  gap: 10px;
  height: 85vh;
}
</style>
